import React, { useEffect, useState } from "react";
import {
  IonCard,
  IonItem,
  IonLabel,
  IonIcon,
  IonCardHeader,
  IonCardTitle,
  IonBadge,
} from "@ionic/react";
import { medicalOutline } from "ionicons/icons";
import { getHospitalizationInstitutions } from "../../../api/server";
import moment from "moment";
import { useIntl } from "react-intl";
const Hospitalizations = (props) => {
  const { activePatient } = props;
  const intl = useIntl();
  const [institutions, setInstitutions] = useState(null);
  useEffect(() => {
    async function fetchInstitutions() {
      const response = await getHospitalizationInstitutions();
      setInstitutions(response.data.items);
    }
    fetchInstitutions();
  }, []);

  const sorted =
    activePatient.hospitalizations &&
    [...activePatient.hospitalizations].sort(
      (a, b) =>
        new Date(b.effective_from).getTime() -
        new Date(a.effective_from).getTime()
    );
  return sorted && sorted.length > 0 ? (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.hospitalizations",
          })}
        </IonCardTitle>
      </IonCardHeader>

      {sorted &&
        sorted.map((item) => {
          const institution =
            institutions &&
            institutions.length > 0 &&
            institutions.filter(
              (i) => i.id === item.hospitalization_institute_id
            )[0];
          const institutionName = institution ? institution.name : "";
          return (
            <IonItem
              button
              onClick={() => {}}
              lines="none"
              detail={false}
              key={item.id}
            >
              <IonIcon icon={medicalOutline} slot="start" />
              <div style={{ padding: "6px 0" }}>
                <IonLabel>{institutionName}</IonLabel>
                <IonLabel color="medium">
                  {`${moment(item.effective_to).format(
                    "DD/MM/YYYY"
                  )} -  ${moment(item.effective_from).format("DD/MM/YYYY")}`}
                </IonLabel>
              </div>
              <IonBadge color="light" slot="end">
                {`${moment(item.effective_to).diff(
                  moment(item.effective_from),
                  "days"
                )} ${intl.formatMessage({
                  id: "app.mobile.number_of_days",
                })}`}
              </IonBadge>
            </IonItem>
          );
        })}
    </IonCard>
  ) : null;
};

export default Hospitalizations;
